(function() {

  var HeadTracker = window.HeadTracker = function( stateController, settings ) {

    var my = this;

    //

    my.settings = settings;
    my.stateController = stateController;

    //
    
    my.settings.detectionThreshold = 0.75, // sensibility, between 0 and 1. Less -> more sensitive
    my.settings.detectionHysteresis = 0.05,

    //

    my.active = false;
    my.initialized = false;
    my.initializing = false;

    //

    // window.addEventListener('TRACKINGINITIALIZE', function(e){

    //   if (my.initialized) return;
      
    //   my.init();
      
    // });

    window.addEventListener('TRACKINGSTOP', function(e){

      if (my.initializing) return;

      if (!my.initialized) return;
      
      if (my.active) {

        JEELIZFACEFILTER.toggle_pause( true, true );

        my.active = false;

      }

    });

    window.addEventListener('TRACKINGSTART', function(e){

      if (my.stateController.isIE) {
        my.dispatchEvent('TRACKINGERROR',{ error:-1 });
        return;
      }

      if (my.initializing) return;

      if (!my.initialized) {
        
        my.initializing = true;
        my.init();
        return;

      };
      
      if (!my.active) {

        my.isDetected = false;

        JEELIZFACEFILTER.toggle_pause( false, true );

        my.active = true;

      }

    });

    //

    my.init = function() {

      my.isDetected = false;

      //

      var bestVideoSettings = {idealWidth:320,idealHeight:240};

      var settings = {

        videoSettings: bestVideoSettings,

        canvasId: my.settings.canvasID,

        NNCPath: my.settings.neuralNetPath, 

        maxFacesDetected: 1,

        callbackReady: function(errCode, spec){

          if (errCode){
            my.dispatchEvent('TRACKINGERROR',{ error:errCode });
            return;
          }

          my.dispatchEvent('TRACKINGAVAILABLE',{});

          my.active = true;

          my.initialized = true;

          my.initializing = false;

        }, 

        // called at each render iteration (drawing loop):

        callbackTrack: function(detectState){

          if (my.isDetected && detectState.detected<my.settings.detectionThreshold-my.settings.detectionHysteresis){
            
            // DETECTION LOST              
            my.dispatchEvent('TRACKINGLOST',{});

            my.isDetected = false;

          } else if (!my.isDetected && detectState.detected>my.settings.detectionThreshold+my.settings.detectionHysteresis){

            // FACE DETECTED
            my.dispatchEvent('TRACKINGFOUND',{});

            my.isDetected = true;

          }

          if (my.isDetected){

            my.dispatchEvent('TRACKINGMOVED', { x:detectState.x, y:detectState.y, rx:detectState.rx, ry:detectState.ry });

          }

        } 
        
      };

      const urlParams = new URLSearchParams(window.location.search);

      var animateDelay = urlParams.get('animateDelay');
  
      if (animateDelay) {

        var value = parseInt(animateDelay);

        settings.animateDelay = value;

      }

      JEELIZFACEFILTER.init( settings );

    };

    my.dispatchEvent = function( name, eventDetail ) {

      if (my.stateController.debugMode) console.log( "EVENT", name );

      var thisEvent;

      if (this.stateController.isIE) {

          // IE11 doesn't support native customEvent....
          thisEvent = document.createEvent("CustomEvent");
          thisEvent.initCustomEvent(name, true, true, eventDetail);

      } else {

          thisEvent = new CustomEvent(name, { "detail": eventDetail });

      }

      my.stateController.eventDispatcher.dispatchEvent( thisEvent );

    };

  };

})();

/*

function main(){
  let CVD = null; // return of Canvas2DDisplay

  var foo=false;

  JEELIZFACEFILTER.init({
    canvasId: 'jeeFaceFilterCanvas',
    NNCPath: '../../../neuralNets/', // root of NN_DEFAULT.json file
    callbackReady: function(errCode, spec){
      if (errCode){
        console.log('AN ERROR HAPPENS. SORRY BRO :( . ERR =', errCode);
        return;
      }

      console.log('INFO: JEELIZFACEFILTER IS READY');
      CVD = JeelizCanvas2DHelper(spec);
      CVD.ctx.strokeStyle = 'yellow';
    },

    // called at each render iteration (drawing loop):
    callbackTrack: function(detectState){
      if (detectState.detected > 0.8){
        // draw a border around the face:
        const faceCoo = CVD.getCoordinates(detectState);
        CVD.ctx.clearRect(0, 0, CVD.canvas.width, CVD.canvas.height);
        CVD.ctx.strokeRect(faceCoo.x, faceCoo.y, faceCoo.w, faceCoo.h);
        CVD.update_canvasTexture();
        if (!foo) {
          console.log(detectState);
          foo=true;
        }
      }
      CVD.draw();
    }
  }); //end JEELIZFACEFILTER.init call
} //end main()

*/;
define("spin/head-tracker", function(){});

